// src/components/VisitorCounter.js

import React, { useState, useEffect } from 'react';

function VisitorCounter() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchVisitorCount = async () => {
      try {
        const response = await fetch('https://andreapodhorsky.com/visitor-api/record-visit', {
          method: 'POST',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.totalVisitors) {
            setCount(data.totalVisitors);
          }
        }
      } catch (error) {
        console.error("Could not fetch visitor count:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVisitorCount();
  }, []);

  if (isLoading) {
    return <span className="ml-1">Loading...</span>;
  }

  return (
    <span className="visitor-counter ml-1 font-medium">
      {count > 0 ? count.toLocaleString() : '...'}
    </span>
  );
}

export default VisitorCounter;